import React from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';
import { Map } from 'immutable';

import { unMuteSession } from 'flow/actions/chat-actions';
import SettingsButton from 'flow/components/ui-components/SettingsButton';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatSessionKey } from 'flow/types/EntityKeys';

import { getProfileLength } from 'flow/utils';

const Mute = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const { id } = useParams<{ id: ChatSessionKey }>();

    const details = useAppSelector((state) =>
        state.chats.getIn(['sessions', id], Map()),
    );

    if (details.get('chatMuted')) {
        const mutedUntil = details.getIn(['chatMuted', 'mutedUntil']);

        return (
            <SettingsButton
                iconKey="notificationsOff"
                onClick={() => dispatch(unMuteSession(id))}
                description={
                    mutedUntil
                        ? `${i18next.t(
                              'profilechooser.until',
                          )} ${getProfileLength(new Date(mutedUntil), i18next)}`
                        : i18next.t('Chat.Mute.UntilForever')
                }
            >
                {i18next.t('Chat.Mute.Inactivate')}
            </SettingsButton>
        );
    }

    return (
        <SettingsButton
            iconKey="notifications"
            onClick={() => openModal('muteConversation', { id })}
        >
            {i18next.t('Chat.Mute.Activate')}
        </SettingsButton>
    );
};

export default Mute;
